export default "__VITE_ASSET__DWpQK2oy__"